export const tableSchemaEnhancer = ({ schema, formData, intl }) => {
  const { fieldsets, properties } = schema;

  return {
    ...schema,
    fieldsets: [
      ...fieldsets,
      {
        id: 'dimensions',
        title: 'Dimensions',
        fields: [
          'width',
          'fixed',
          'interactive',
          'overflow',
          'mobile_overflow',
        ],
      },
    ],
    properties: {
      ...properties,
      width: {
        title: 'Width',
        choices: [
          ['normal', 'Normal'],
          ['wide', 'Wide'],
        ],
        default: 'normal',
        isRequired: true,
      },
      fixed: {
        title: 'Column width',
        choices: [
          ['uniform', 'Uniform'],
          ['adjust', 'Adjust to content'],
        ],
        default: 'adjust',
        isRequired: true,
      },
      interactive: {
        title: 'Highlight on hover',
        type: 'boolean',
      },
      overflow: {
        title: 'Overflow behavior',
        choices: [
          ['scroll', 'Scroll'],
          ['break', 'Break text'],
        ],
        default: 'scroll',
        isRequired: true,
      },
      mobile_overflow: {
        title: 'Mobile overflow behavior',
        choices: [
          ['scroll', 'Scroll'],
          ['break', 'Break text'],
        ],
        default: 'scroll',
        isRequired: true,
      },
    },
    required: ['width'],
  };
};
